// рандомное число в интервале от min до max включительно
export function randomInteger(min, max) {
    // случайное число от min до (max+1)
    let rand = min + Math.random() * (max + 1 - min);
    return Math.floor(rand);
}

// throttle функция
export function throttle(fn, throttleTime) {
    let isThrottled = false;

    return function () {
        if (isThrottled) return;

        fn.apply(this, arguments);

        isThrottled = true;

        setTimeout(function () {
            isThrottled = false;
        }, throttleTime);
    };
}

export function debounce(func, wait, immediate) {
    let timeout;

    return function () {
        let context = this,
            args = arguments;
        let later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        let callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}
